/* eslint-disable no-unused-vars */
import './bootstrap';
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';
import i18n from './i18n';

window.dictionaries = {
  login: {
    headlineCreateUser: 'Opret bruger',
    introTextCreateUser:
      'Vi har fået nyt loginsystem for at forbedre sikkerheden omkring dine data. Har du ikke brugt det nye login før, så klik på "Opret en ny bruger" nedenfor',
    dividerText: 'eller',
  },
};
Vue.use(VueReCaptcha, { siteKey: '6Lc9kjIaAAAAANXrXaMZ4Llp0WAJUzwIIsNU8dg5' });

const app = new Vue({
  el: '#app',
  i18n,
  render: (createElement) => createElement(App),
});
